import store from "@/state/store";
import i18n from "@/i18n";

export default [
    {
        path: "/login-callback",
        name: "login-callback",
        component: () => import("../views/account/login-callback.vue"),
        meta: {
            title: "callback",
            authRequired: false,
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/account/register.vue"),
        meta: {
            title: "Register",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                // if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                // } else {
                    // Continue to the login page
                    // next();
                // }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/",
        name: "default",
        redirect: "/repair-request",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/index"),
    },
    {
        path: "/unauthorized",
        name: "unauthorized",
        meta: {
            title: "Unauthorized",
            authRequired: true,
        },
        component: () => import("../views/dashboard/unauthorized"),
    },
    /* 维修请求 */
    {
        path: "/repair-request",
        name: "repair-request",
        redirect: "/repair-request/list",
        meta: {
            title: "维修请求",
            authRequired: true,
            keepAlive: true,
        },
        component: () => import("../views/repair-request/index"),
        children: [
            {
                path: "/repair-request/list",
                name: "repair-request-list",
                meta: {
                    title: "维修请求",
                    authRequired: true,
                },
                component: () => import("../views/repair-request/components/RepairList.vue"),
            },
            {
                path: "/repair-request/detail/:id",
                name: "repair-request-detail",
                meta: {
                    title: "维修请求",
                    authRequired: true,
                },
                component: () => import("../views/repair-request/components/Detail.vue"),
            },
            {
                path: "/repair-request/add",
                name: "repair-request-add",
                meta: {
                    title: "维修请求",
                    authRequired: true,
                },
                component: () => import("../views/repair-request/components/Add.vue"),
            },
        ]
    },
    /* 保养请求 */
    {
        path: "/maintain-request",
        name: "maintain-request",
        redirect: "/maintain-request/list",
        meta: {
            title: "保养请求",
            authRequired: true,
        },
        component: () => import("../views/maintain-request/index"),
        children: [
            {
                path: "/maintain-request/list",
                name: "maintain-request-list",
                meta: {
                    title: "保养请求",
                    authRequired: true,
                },
                component: () => import("../views/maintain-request/components/MaintainList.vue"),
            },
            {
                path: "/maintain-request/detail/:id",
                name: "maintain-request-detail",
                meta: {
                    title: "保养请求",
                    authRequired: true,
                },
                component: () => import("../views/maintain-request/components/Detail.vue"),
            },
            {
                path: "/maintain-request/add",
                name: "maintain-request-add",
                meta: {
                    title: "保养请求",
                    authRequired: true,
                },
                component: () => import("../views/maintain-request/components/Add.vue"),
            },
        ]
    },
    {
        path: "/work-order",
        name: "work-order",
        meta: {
            title: "工单管理",
            authRequired: true,
            keepAlive: true,
        },
        component: () => import("../views/work-order"),
    },
    {
        path: "/work-order-detail/:id",
        name: "work-order-detail",
        meta: {
            title: "工单详情",
            authRequired: true,
        },
        component: () => import("../views/work-order/detail"),
    },
    {
        path: "/work-order-add/:type?",
        name: "work-order-add",
        meta: {
            title: "新建工单",
            authRequired: true,
        },
        component: () => import("../views/work-order/add"),
    },
    {
        path: "/service-report",
        name: "service-report",
        meta: {
            title: "服务报告",
            authRequired: true,
        },
        component: () => import("../views/service-report/index"),
    },
    {
        path: "/service-report-download/:request_id",
        name: "service-report-download",
        meta: {
            title: "服务报告下载",
            authRequired: true,
        },
        component: () => import("../views/widgets/download"),
    },
    {
        path: "/service-company",
        name: "service-company",
        meta: {
            title: "代理商",
            authRequired: true,
        },
        component: () => import("../views/service-company/index"),
    },
    {
        path: "/service-company-detail/:id",
        name: "service-company-detail",
        meta: {
            title: "代理商",
            authRequired: true,
        },
        component: () => import("../views/service-company/detail/index"),
    },
    {
        path: "/customer",
        name: "customer",
        meta: {
            title: "客户",
            authRequired: true,
        },
        component: () => import("../views/customer/index"),
    },
    {
        path: "/customer/:id",
        name: "customer-detail",
        meta: {
            title: "客户",
            authRequired: true,
        },
        component: () => import("../views/customer/detail/index"),
    },
    {
        path: "/model-detail",
        name: "model-detail",
        meta: {
            title: "物模型", authRequired: true,
        },
        component: () => import("../views/model/tree/index"),
    },
    {
        path: "/model",
        name: "model",
        meta: {
            title: "物模型", authRequired: true,
        },
        component: () => import("../views/model/index"),
    },
    {
        path: "/model/form",
        name: "model-form",
        meta: {
            title: "物模型表单", authRequired: true,
        },
        component: () => import("../views/model/modelForm/index"),
    },
    {
        path: "/asset",
        name: "asset-detail",
        meta: {
            title: "设备", authRequired: true,
        },
        component: () => import("../views/asset/detail/index"),
    },
    {
        path: "/asset/form",
        name: "asset-form",
        meta: {
            title: "设备表单", authRequired: true,
        },
        component: () => import("@/views/asset/Form"),
    },
    {
        path: "/data-integration",
        name: "data-integration",
        meta: {
            title: "数据集成", authRequired: true,
        },
        component: () => import("@/views/dataIntegration/index"),
    },
    {
        path: "/equipment-management",
        name: "equipment-management",
        meta: {
            title: "设备管理", authRequired: true, keepAlive: true,
        },
        component: () => import("@/views/equipmentManagement/index"),
    },
    {
        path: "/equipment-detail",
        name: "equipment-detail",
        meta: {
            title: "设备详情", authRequired: true,
        },
        component: () => import("@/views/equipmentDetail/index"),
    },
    {
        path: "/iot/health-monitor",
        name: "health-monitor",
        meta: {
            title: "健康监控", authRequired: true,
        },
        component: () => import("@/views/healthMonitor/index"),
    },
    {
        path: "/iot/event-management",
        name: "event-management",
        meta: {
            title: "事件管理", authRequired: true,
        },
        component: () => import("@/views/eventManagement/index"),
    },
    {
        path: "/iot/atlas-analysis",
        name: "atlas-analysis",
        meta: {
            title: "图谱分析", authRequired: true,
        },
        component: () => import("@/views/atlasAnalysis/index"),
    },
    {
        path: "/iot/expert-system",
        name: "expert-system",
        meta: {
            title: "专家系统服务", authRequired: true,
        },
        component: () => import("@/views/expertSystem/index"),
    },
    {
        path: "/organization-account-management",
        name: "organization-account-management",
        meta: {
            title: "组织-账号管理", authRequired: true,
        },
        component: () => import("@/views/organization/index"),
    },
    {
        path: "/user-account-management",
        name: "user-account-management",
        meta: {
            title: "用户-账号管理", authRequired: true,
        },
        component: () => import("@/views/user/index"),
    },
    {
        path: "/user-profile",
        name: "user-profile",
        meta: {
            title: "个人信息", authRequired: true,
        },
        component: () => import("@/views/profile/index"),
    },
    {
        path: "/enterprise-info",
        name: "enterprise-info",
        meta: {
            title: "企业信息", authRequired: true,
        },
        component: () => import("@/views/enterprise-info/index"),
    },
    {
        path: "/get-user-status",
        name: "get-user-status",
        meta: {
            title: "用户信息", authRequired: true,
        },
        component: () => import("@/views/profile/user-status/user-status"),
    },
    {
        path: "/ciie",
        name: "ciie",
        meta: {
            title: "ciie", authRequired: true,
        },
        component: () => import("@/views/profile/user-status/ciie"),
    },
    {
        path: "/manufacturer",
        name: "manufacturer",
        meta: {
            title: "设备制造商", authRequired: true,
        },
        component: () => import("@/views/manufacturer/index"),
    },
    {
        path: "/manufacturer/:id",
        name: "manufacturer-detail",
        meta: {
            title: "设备制造商", authRequired: true,
        },
        component: () => import("@/views/manufacturer/detail/index"),
    },
    {
        path: "/role-management",
        name: "role-management",
        meta: {
            title: "角色管理", authRequired: true,
        },
        component: () => import("@/views/role/index"),
    },
    {
        path: "/permission-management",
        name: "permission-management",
        meta: {
            title: "权限管理", authRequired: true,
        },
        component: () => import("@/views/role/index"),
    },
    {
        path: "/business-opportunity",
        name: "business-opportunity",
        meta: {
            title: i18n.global.t('menu.after-sales_service.business-opportunity'),
            authRequired: true,
        },
        component: () => import("../views/business-opportunity"),
    },
    {
        path: "/maintenance-plan",
        name: "maintenance-plan",
        meta: {
            title: i18n.global.t('menu.after-sales_service.maintenance-plan'),
            authRequired: true,
        },
        component: () => import("../views/maintain-plan"),
    },

    {
        path: "/app-download",
        name: "app-download",
        meta: {
            title: "APP下载", authRequired: false,
        },
        component: () => import("../views/app/download.vue"),
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            title: "dashboard", authRequired: false,
        },
        component: () => import("../views/dashboard/index.vue"),
    },
    {
        path: "/equipment-statistics",
        name: "EquipmentStatistics",
        meta: {
            title: "EquipmentStatistics", authRequired: false,
        },
        component: () => import("../views/dashboard/EquipmentStatistics.vue"),
    },
    {
        path: "/work-order-dashboard",
        name: "workOrderDashboard",
        meta: {
            title: "workOrderDashboard", authRequired: false,
        },
        component: () => import("../views/dashboard/workOrderDashboard.vue"),
    },
    {
        path: "/business-opportunity-dashboard",
        name: "businessOpportunityDashboard",
        meta: {
            title: "businessOpportunityDashboard", authRequired: false,
        },
        component: () => import("../views/dashboard/businessOpportunityDashboard.vue"),
    }
    //dashboard入口文件

    ,
    {
        path: "/entryPage",
        name: "entryPage",
        meta: {
            title: "entryPage", authRequired: false,
        },
        component: () => import("../views/dashboard/entryPage.vue"),
    }
    //统计

    ,
    {
        path: "/statisticsDashboard",
        name: "statisticsDashboard",
        meta: {
            title: "statisticsDashboard", authRequired: false,
        },
        component: () => import("../views/dashboard/statisticsDashboard.vue"),
    },

    //单体设备
    {
        path: "/device_monitoring",
        name: "deviceMonitoring",
        meta: {
            title: "deviceMonitoring", authRequired: false,
        },
        component: () => import("../views/dashboard/DeviceMonitoring.vue"),
    },
    // Welcome

    {
        path: "/welcome",
        name: "Welcome",
        meta: {
            title: "Welcome", authRequired: false,
        },
        component: () => import("../views/Welcome.vue"),
    },

    {
        path: "/auditReport",
        name: "auditReport",
        meta: {
            title: "auditReport", authRequired: false,
        },
        component: () => import("../views/auditReport.vue"),
    },
    {
        path: "/lifeIndex",
        name: "lifeIndex",
        meta: {
            title: "lifeIndex", authRequired: false,
        },
        component: () => import("../views/lifeIndex.vue"),
    },
        
    /* VSD420总貌 */
    {
        path: '/VSD420-OverAll',
        name: 'VSD420-OverAll',
        component: () => import('@/views/dashboard/devices/VSD420-OverAll.vue'),
        meta: {
            // modelId: 'VSD420-OverAll' //判断模型是否展示
            title:i18n.global.t("digital_twin")
        },
    },
    /* 故障预测 */
    {
        path: '/VSD420-Fault',
        name: 'VSD420-Fault',
        component: () => import('@/views/dashboard/devices/VSD420-Fault'),
        meta: {
            needLogin: true, //需要加校检判断的路由
            modelId: 'VSD420-Fault', //判断模型是否展示
            title:i18n.global.t('menu.intelligent-operation-maintenance.intelligent-diagnosis'),
        },
    },
/* 高频振动 */
    {
        path: '/VSD420-HighVibration',
        name: 'VSD420-HighVibration',
        component: () => import('@/views/dashboard/devices/VSD420-HighVibration'),
        meta: {
            needLogin: true, //需要加校检判断的路由
            modelId: 'VSD420-HighVibration' //判断模型是否展示
        },
    },
     /* 数据仿真 */
     {
        path: '/VSD420-Simulation',
        name: 'VSD420-Simulation',
        component: () => import('@/views/dashboard/devices/Simulation'),
        meta: {
            needLogin: true, //需要加校检判断的路由
        },
    },
     /*能耗分析 */
     {
        path: '/EnergyConsumption',
        name: 'EnergyConsumption',
        component: () => import('@/views/dashboard/devices/other_page/EnergyConsumption'),
        meta: {
            needLogin: true, //需要加校检判断的路由
        },
    },
    {
        path: '/Home',
        name: 'Home',
        component: () => import('@/views/dashboard/devices/Home'),
        redirect: '/VSD420-OverAll',
        meta: {
            needLogin: true //需要加校检判断的路由
        },
    },
    //节能降碳分析
    {
        path: "/EnergyConsumption706",
        name: "EnergyConsumption706",
        meta: {
            title: "EnergyConsumption706", authRequired: false,
        },
        component: () => import("../views/dashboard/devices/other_page/EnergyConsumption706.vue"),
    },
    {
        path: "/fullIndex",
        name: "fullIndex",
        meta: {
            title: "fullIndex", authRequired: false,
        },
        component: () => import("../views/dashboard/fullIndex.vue"),
    },
    {
        path: "/auditing-order",
        name: "auditing-order",
        meta: {
            title: "Auditing工单管理",
            authRequired: true,
            keepAlive: true,
        },
        component: () => import("../views/auditing-order"),
    },
    {
        path: "/auditing-order-detail/:id",
        name: "auditing-order-detail",
        meta: {
            title: "工单详情",
            authRequired: true,
        },
        component: () => import("../views/auditing-order/detail"),
    },
    {
        path: "/auditing-order-add/:type?",
        name: "auditing-order-add",
        meta: {
            title: "新建工单",
            authRequired: true,
        },
        component: () => import("../views/auditing-order/add"),
    },
    {
        path: "/energy-conf",
        name: "energy-conf",
        meta: {
            title: "能耗管理",
            authRequired: true,
        },
        component: () => import("../views/energy-conf/index.vue"),
    },
];
